// Fonts and Components
import './App.css';
import BootstrapNavbar from "./components/navbar";

// Pages
import Home from './components/home.js';
import Services from './components/services.js'
import Portfolio from './components/portfolio.js'
import About from './components/about.js';
import Canary from "./components/canary";

// React Components
import {Route, Routes, BrowserRouter as Router} from "react-router-dom";

function App() {
  return (
    <div className="App">
        <BootstrapNavbar />
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/about" element={<About />} />
                <Route path="/canary" element={<Canary />} />
            </Routes>
        </Router>
        {/*<Footer/>*/}
    </div>
  );
}

export default App;